const routes = [
    {
        path: "/coop/student-bans",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true
        }
    }
];

export default routes;
